/*******************************************************************************
 * Copyright (c) 2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export const X_PSP_TYPE = {
  assumeIdentity: 'assumeIdentity',
  getCustomerToken: 'getCustomerToken',
  integratorManageFinancialEntity: 'integratorManageFinancialEntity',
  spiIntegratorManageParticipant: 'spiIntegratorManageParticipant',
  getFinancialEntityToken: 'getFinancialEntityToken',
  noAuhtorizationHeader: 'noAuhtorizationHeader',
  getParticipantToken: 'getParticipantToken',
  useBaseToken: 'useBaseToken',
};
